import {
  bl_fi_generic_doc_editing_lock_RowClass,
  bl_fi_generic_doc_editing_lock_RowInterface,
} from "../../dbschema/index";
import { BaseContainerModel } from "../base-container.model";

export class GenericDocLockContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_editing_lock: bl_fi_generic_doc_editing_lock_RowInterface =
    new bl_fi_generic_doc_editing_lock_RowClass();
}
